export const getQueryParam = name => {
  var params = location.search.substr(location.search.indexOf('?') + 1);
  params = params.split('&');
  const results = findQueryMatch(params,function(item){
    if(item && item.length){
      return item.split('=')[0] === name;
    }
  })
  return results && results.split('=')[1];
};

const findQueryMatch = (arr = [],callback) => {
  for(var i = 0;i<arr.length;i++){
    var match = callback(arr[i]);
    if(match){
      return  arr[i];
    }
  }
}